<template>
  <div>
    <el-table
      :data="newsletters.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column label="Name" prop="name" sortable></el-table-column>
      <el-table-column label="E-mail" prop="email" sortable></el-table-column>
      <el-table-column label="Signup date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="newsletters.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="newsletters.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('contentHome', [
      'newsletters',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('contentHome', ['read']),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    }
  },

  created() {
    this.read()
  }
}
</script>
